export const COMPOSING_EMAIL = 'COMPOSING_EMAIL';
export const EMAIL_LOADED = 'EMAIL_LOADED';
export const EMAIL_SAVED_STATUS = 'EMAIL_SAVED_STATUS';
export const AUTO_THREADING_DEFAULT = 'AUTO_THREADING_DEFAULT';
export const GET_EMAIL = 'GET_EMAIL';
export const HIDE_AUTOTHREADING_ALERT = 'HIDE_AUTOTHREADING_ALERT';
export const RECENT_RECORDS_SUCCESS = 'RECENT_RECORDS_SUCCESS';
export const RECENT_RECORDS_FAILURE = 'RECENT_RECORDS_FAILURE';
export const EMAIL_SEARCH = 'EMAIL_SEARCH';
export const EMAIL_CLEARSEARCH = 'EMAIL_CLEARSEARCH';
export const SELECT_RECORDS = 'SELECT_RECORDS';
export const UNSELECT_RECORD = 'UNSELECT_RECORD';
export const UPDATE_RECORDS = 'UPDATE_RECORDS';
export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const SAVING_TO_TIMELINE = 'SAVING_TO_TIMELINE';
export const SAVING_TO_TIMELINE_DEFAULT = 'SAVING_TO_TIMELINE_DEFAULT';
export const IS_SAVING_EMAIL = 'IS_SAVING_EMAIL';
export const SAVE_EMAIL_SUCCESS = 'SAVE_EMAIL_SUCCESS';
export const SAVE_EMAIL_FAILURE = 'SAVE_EMAIL_FAILURE';
export const SET_SUBJECT = 'SET_SUBJECT';
export const SET_BODY = 'SET_BODY';
export const SET_TIMELINE_SUBJECT = 'SET_TIMELINE_SUBJECT';
export const SET_DOCRIO_SUBJECT = 'SET_DOCRIO_SUBJECT';
export const LOAD_ICONS = 'LOAD_ICONS';
export const IS_CHANGING_EMAIL_SAVE_LOCATION = 'IS_CHANGING_EMAIL_SAVE_LOCATION';
export const IS_LOADING_RECORD = 'IS_LOADING_RECORD';
export const IS_EMAIL_EDITED = 'IS_EMAIL_EDITED';
export const IS_SUBJECT_EDITED = 'IS_SUBJECT_EDITED';
export const IS_PRESAVE = 'IS_PRESAVE';
export const IS_ACTIVITY_TIMELINE_SAVED = 'IS_ACTIVITY_TIMELINE_SAVED';
export const IS_FIRST_SAVE = 'IS_FIRST_SAVE';
export const AUTO_THREADING_TOGGLED = 'AUTO_THREADING_TOGGLED';
export const SAVING_TO_TIMELINE_TOGGLED = 'SAVING_TO_TIMELINE_TOGGLED';
export const SET_REMOVAL_JOB_ID = 'SET_REMOVAL_JOB_ID';
export const IS_REMOVING_SAVE_LOCATION = 'IS_REMOVING_SAVE_LOCATION';
export const SET_EMAIL_SALESFORCE_IDS = 'SET_EMAIL_SALESFORCE_IDS';
export const SET_IS_SEARCHING_RELATED_RECORDS = 'SET_IS_SEARCHING_RELATED_RECORDS';
export const SET_OWNER_EMAIL = 'SET_OWNER_EMAIL';
export const SET_OWNER_DISPLAY_NAME = 'SET_OWNER_DISPLAY_NAME';
export const SET_DELEGATE_ERROR = 'SET_DELEGATE_ERROR';
export const SET_INITIAL_EMAIL_AUTO_THREADED_RECORDS = 'SET_INITIAL_EMAIL_AUTO_THREADED_RECORDS';

export const composingEmail = (draftId, presave) => ({
  type: COMPOSING_EMAIL,
  payload: { draftId, presave },
});

export const isEmailEdited = (status) => ({
  type: IS_EMAIL_EDITED,
  status,
});

export const isSubjectEdited = (status) => ({
  type: IS_SUBJECT_EDITED,
  status,
});

export const isPresave = (status) => ({
  type: IS_PRESAVE,
  status,
});

export const emailLoaded = (email) => ({
  type: EMAIL_LOADED,
  emails: {
    ...email,
    attachments: email?.attachments?.map((attachment) => ({
      id: attachment.id,
      name: attachment.name,
      size: attachment.size,
      contentType: attachment.contentType,
      attachmentType: attachment.attachmentType,
    })),
  },
});

export const setAutoThreadingDefault = (status) => ({
  type: AUTO_THREADING_DEFAULT,
  status,
});

export const getEmail = () => ({
  type: GET_EMAIL,
});

// savedStatus is now an object of { <recordId>: boolean, <recordId>: boolean, ... }
export const emailSavedStatus = (email, savedStatus) => (
  {
    type: EMAIL_SAVED_STATUS,
    savedStatus, // This is the Activity Timeline save status!
    recentRecords: email.AllRecords,
    listViews: email.ListViewRecords,
  }
);

// savedStatus is now an object of { <recordId>: boolean, <recordId>: boolean, ... }
export const activityTimelineSaved = (savedStatus) => ({
  type: IS_ACTIVITY_TIMELINE_SAVED,
  savedStatus,
});

export const selectRecords = (items) => ({
  type: SELECT_RECORDS,
  selectedRecords: items,
});

export const unselectRecord = (record) => ({
  type: UNSELECT_RECORD,
  record,
});

export const updateRecords = (records) => ({
  type: UPDATE_RECORDS,
  records,
});

export const loadSettings = (settings) => ({
  type: LOAD_SETTINGS,
  settings,
});

export const savingToTimeline = (status) => ({
  type: SAVING_TO_TIMELINE,
  status,
});

export const savingToTimelineDefault = (status) => ({
  type: SAVING_TO_TIMELINE_DEFAULT,
  status,
});

export const saveEmailSuccess = () => ({
  type: SAVE_EMAIL_SUCCESS,
});

export const saveEmailFailure = (error) => ({
  type: SAVE_EMAIL_FAILURE,
  payload: {
    error,
  },
});

export const setSubject = (subject) => ({
  type: SET_SUBJECT,
  subject,
});

export const setBody = (emailBody) => ({
  type: SET_BODY,
  emailBody,
});

export const setTimelineSubject = (subject) => ({
  type: SET_TIMELINE_SUBJECT,
  subject,
});

export const setDocrioSubject = (subject) => ({
  type: SET_DOCRIO_SUBJECT,
  subject,
});

export const loadIcons = (icons) => ({
  type: LOAD_ICONS,
  icons,
});

export const isChangingEmailSaveLocation = (value) => ({
  type: IS_CHANGING_EMAIL_SAVE_LOCATION,
  payload: value,
});

export const autoThreadingToggled = (value) => ({
  type: AUTO_THREADING_TOGGLED,
  payload: value,
});

export const savingToTimelineToggled = (value) => ({
  type: SAVING_TO_TIMELINE_TOGGLED,
  payload: value,
});

export const setRemovalJobId = (jobId) => ({
  type: SET_REMOVAL_JOB_ID,
  jobId,
});

export const isRemovingSaveLocation = (status) => ({
  type: IS_REMOVING_SAVE_LOCATION,
  status,
});

export const setEmailSalesforceIds = (emailSalesforceIds) => ({
  type: SET_EMAIL_SALESFORCE_IDS,
  emailSalesforceIds,
});

export const setIsSearchingRelatedRecords = (status) => ({
  type: SET_IS_SEARCHING_RELATED_RECORDS,
  status,
});

export const setOwnerEmail = (ownerEmail) => ({
  type: SET_OWNER_EMAIL,
  ownerEmail,
});

export const setOwnerDisplayName = (ownerDisplayName) => ({
  type: SET_OWNER_DISPLAY_NAME,
  ownerDisplayName,
});

export const setDelegateError = (error) => ({
  type: SET_DELEGATE_ERROR,
  error,
});

export const setInitialEmailAutoThreadedRecords = (value) => ({
  type: SET_INITIAL_EMAIL_AUTO_THREADED_RECORDS,
  payload: value,
});
